/* eslint-disable max-len */
import successCheck from 'assets/lottie/successCheck.json';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { Breakpoints } from 'common/enums';
import { Modal } from 'common/modal';
import { useMediaQuery } from 'hooks/use-media-query';
import Lottie from 'lottie-react';
import { VaultCard } from 'pages/sign-up-onboarding/components/vault-card/vault-card';
import React from 'react';
import styles from './final-onboarding-modal.module.scss';

type PreBuiltQuestionsModalProps = {
  vaultTitle: string;
  vaultImage: string;
  onClose: () => void;
};

const FinalOnboardingModal: React.FC<PreBuiltQuestionsModalProps> = ({
  vaultTitle,
  vaultImage,
  onClose,
}) => {
  const isMobile = useMediaQuery(`(max-width: ${Breakpoints.sm}px)`);
  return (
    <Modal
      onClose={onClose}
      disableManualClosing
      contentClassName={styles.contentModal}
      closeOnOutsideClick
    >
      <div className={styles.modal}>
        {!isMobile && (
          <VaultCard
            image={vaultImage}
            name={vaultTitle}
            subtitle="A life story"
          />
        )}
        <div className={styles.content}>
          <Lottie
            animationData={successCheck}
            className={styles.lottie}
            loop={false}
          />
          <p className="text__heading4__gray800">Your Vault is ready!</p>
          <p className="text__body__regular__large__gray800">
            You’re all set to start capturing albums that will last for
            generations.
          </p>

          <Button
            buttonStyle={ButtonStyle.PrimaryFilled}
            buttonSize={ButtonSize.Medium}
            className={styles.button}
            onClick={onClose}
          >
            Start Now
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export { FinalOnboardingModal };
